import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { CheckoutPreOrderStyled } from '../CheckoutPreOrderStyled';
import { rem } from 'polished';

export const CheckoutPreOrderStyledAC = styled(CheckoutPreOrderStyled)`
    .consent-checkbox {
        margin-top: ${rem(40)};
        margin-bottom: ${rem(20)};
    }

    .submitButton {
        width: 100%;

        button {
            width: 100%;
            margin-top: ${rem(15)};

            @media (min-width: ${breakpoints.xs}px) {
                height: ${rem(50)};
            }
        }
    }
`;
